// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Poland from '../_raw/flag/icon_flag_poland.png';

export default () => <img src={Poland} alt="Poland" />;
